
export default function HelpDevicesItemsService(gettext) {

    'ngInject';

    this.getModule = function () {

        var module = {
            "id": "devices",
            "name": gettext("Devices"),
            "description": gettext("This area is used to manage and activate telematics devices."),
            "icon": "fas fa-question-circle",
            "priority": 3,
            "items": [{
                "orderid": 3.1,
                "itemid": "devicesbase",
                "helpitemid": "devices",
                "name": gettext("View Devices"),
                "templateUrl": "devices/devices.html"
            },
            {
                "orderid": 3.2,
                "itemid": "devicesdetail",
                "helpitemid": "devices",
                "name": gettext("Device Details"),
                "templateUrl": "devices/devices.details.html"
            },
            {
                "orderid": 3.3,
                "itemid": "devicesactivations",
                "helpitemid": "devices.activate",
                "name": gettext("Activations"),
                "templateUrl": "devices/devices.activation.single.html"
            },
            ]
        };

        return module;
    };
}
